<template>
  <div>
    <v-app-bar
      fixed
      color="white"
      elevate-on-scroll
    >
    <v-row class="align-center">
        <v-col cols="2">
          <v-btn
            icon
            tile
            small
            color="primary"
            class="bg-secondary-50 rounded"
            @click="$router.go('challenge')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="pa-0">
          <v-btn
            outlined
            dense
            small
            color="primary"
            class="border-radius-1 text-transform-none pl-4 ml-4 position-relative"
            @click="openDialog"
          >
            <v-img
              :src="require(`@/assets/img/icons/treasure.png`)"
              height="48px"
              width="48px"
              class="image-overlay"
            ></v-img>
            {{$t('challenge.rewards')}}
          </v-btn>
        </v-col>
        <v-col cols="2">
          <v-btn
              icon
              dark
              tile
              small
              class="bg-primary rounded"
              @click.stop="abrirDrawer"
            >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>
    
    <PrizeChallenge :dialogVisible="dialogVisible" />
    <ChallengeSidenav />
  </div>
</template>

<script>
import PrizeChallenge from '../PrizeChallenge.vue';
import ChallengeSidenav from './ChallengeSidenav.vue';

export default {
  components: {
    PrizeChallenge,
    ChallengeSidenav
  },
  data () {
    return {
      dialogVisible: false,
      utilsToggle: false,
    }
  },
  methods: {
    // Open dialog recompensas
    openDialog() {
      this.$root.$emit('openDialog', true);
    },
    // Open drawer herramientas
    abrirDrawer() {
      try {
        this.$root.$emit('utilsToggle', true);
      } catch (error) {
        console.error('Error al emitir evento utilsToggle:', error);
      }
    }
  },
}
</script>

<style lang="scss">
.image-overlay {
  position: absolute;
  top: -12px;
  left: -46px;
  z-index: 1;
}
.v-sheet.v-toolbar.v-app-bar {
  padding-top: 0;
}
</style>